import useApplicationManagerProject from 'Hooks/queries/useApplicationManagerProject';
import { useCheckUserGroupsAccess } from 'Modules/Auth/hooks/useCheckUserGroupsAccess';
import useInfluencerPlan from 'Modules/Advertising/InfluencerPlan/hooks/queries/useInfluencerPlan';

export default function useRoundPlan(appManagerId: number | null | undefined) {
    const isUserAdmin = useCheckUserGroupsAccess(['user_admin'], 'all');
    const { data: applicationManagerProject } = useApplicationManagerProject(appManagerId, {
        enabled: !!appManagerId && !!isUserAdmin,
    });

    const { data: influencerPlan } = useInfluencerPlan(applicationManagerProject?.round_influencer_plan_id);

    return {
        roundPlan: influencerPlan,
    };
}
